import { getOssProxyOrFail } from "./api";
import { z } from "zod";

const cxFeatureFlagsSchema = z.object({ cxsWithDashV2FeatureFlag: z.literal(true).optional() });
export type CxFeatureFlags = z.infer<typeof cxFeatureFlagsSchema>;

const FEATURE_FLAGS_URL = `/medical/v1/feature-flags`;

/** ---------------------------------------------------------------------------
 * GET /feature-flags
 *
 * Get feature flags that are **actively enabled** for the CX.
 * @return 200 Active feature flags.
 */
export async function getCxFeatureFlags(): Promise<CxFeatureFlags> {
  const apiOssProxy = getOssProxyOrFail();
  try {
    const resp = await apiOssProxy.get(FEATURE_FLAGS_URL);
    return cxFeatureFlagsSchema.parse(resp.data);
  } catch (error) {
    return {};
  }
}
